import {createApi} from "@reduxjs/toolkit/query/react";
import {axiosBaseQuery} from "./axiosBaseQuery";

const CG_PLATFORM = 'website';

export const commerceApi = createApi({
    reducerPath: 'commerceApi',
    baseQuery: axiosBaseQuery({
        baseUrl: '/commerce/api',
    }),
    tagTypes: ['commerce'],
    endpoints: (build) => ({
        selectPresentBenefit: build.mutation({
            query: (data) => ({
                url: '/coupons/free/select-present-benefit',
                method: 'POST',
                data,
                headers: {
                    'Content-Type': 'application/json'
                }
            })
        }),
        getUserUsedPaidCoupons: build.mutation({
            query: (data) => ({
                url: '/coupons/paid/get-user-used-paid-coupons',
                method: 'POST',
                data,
                headers: {
                    'Content-Type': 'application/json'
                }
            })
        }),
        getUserCouponsForBenefit: build.mutation({
            query: (data) => ({
                url: '/coupons/getUserCouponsForBenefit',
                method: 'POST',
                data,
                headers: {
                    'Content-Type': 'application/json'
                }
            })
        }),
        getUserUsedDownloadedCoupons: build.mutation({
            query: (data) => ({
                url: '/coupons/free/get-user-used-coupons',
                method: 'POST',
                data,
                headers: {
                    'Content-Type': 'application/json'
                }
            })
        }),
        changeFreeCouponArchiveStatus: build.mutation({
            query: (data) => ({
                url: '/coupons/free/change-coupon-archive-status',
                method: 'POST',
                data,
                headers: {
                    'Content-Type': 'application/json'
                }
            })      
        }),
        changePaidCouponArchiveStatus: build.mutation({
            query: (data) => ({
                url: '/coupons/paid/change-coupon-archive-status',
                method: 'POST',
                data,
                headers: {
                    'Content-Type': 'application/json'
                }
            })
        }),
        cancelPaidCoupons: build.mutation({
            query: (data) => ({
                url: '/coupons/paid/cancel',
                method: 'POST',
                data,
                headers: {
                    'Content-Type': 'application/json'
                }
            })
        }),
        addToken: build.mutation({
            query: (params = {}) => ({
                url: '/cg/addToken',
                method: 'POST',
                data: { platform: CG_PLATFORM },
                params: { useGlobalLoader: params?.useGlobalLoader ?? false },
            }),
            transformResponse: (response) => {
                const data = response?.data ?? response;
                if (typeof data === 'string') return data;
                return data?.addPaymentMethodLink ?? data?.url ?? '';
            },
        }),
        getTokenRes: build.mutation({
            query: (params = {}) => ({
                url: '/cg/getTokenRes',
                method: 'POST',
                data: { platform: CG_PLATFORM },
                params: { useGlobalLoader: params?.useGlobalLoader ?? false },
            }),
            transformResponse: (response) => {
                const data = response?.data ?? response ?? {};
                return {
                    isFailure: Boolean(data.isFailure),
                    err: data.err,
                };
            },
        }),
        removeToken: build.mutation({
            query: ({ tokenId, useGlobalLoader = false }) => ({
                url: '/cg/removeToken',
                method: 'POST',
                data: { tokenId, platform: CG_PLATFORM },
                params: { useGlobalLoader },
            }),
        }),
        setDefaultToken: build.mutation({
            query: ({ tokenId, useGlobalLoader = false }) => ({
                url: '/cg/setDefaultToken',
                method: 'POST',
                data: { tokenId, platform: CG_PLATFORM },
                params: { useGlobalLoader },
            }),
        }),
    })
})

export const {
    useSelectPresentBenefitMutation,
    useGetUserUsedPaidCouponsMutation,
    useGetUserUsedDownloadedCouponsMutation,
    useChangeFreeCouponArchiveStatusMutation,
    useChangePaidCouponArchiveStatusMutation,
    useCancelPaidCouponsMutation,
    useGetUserCouponsForBenefitMutation,
    useAddTokenMutation,
    useGetTokenResMutation,
    useRemoveTokenMutation,
    useSetDefaultTokenMutation,
} = commerceApi;